import React, { ComponentProps, FC, useRef } from 'react';
import { SpinnerIcon } from '@components/icons/Spinner.icon';
import { Overlay } from '@components/Overlay/Overlay.component';
import { useLockBodyScroll } from '@layout/business/LockBodyScroll.hook';

type Props = Omit<ComponentProps<typeof Overlay>, 'visible'> & { visible?: boolean; withSpinner?: boolean };

const SPINNER_SIZE = '10vw';

const FullPageLoader: FC<Props> = ({ visible = false, withSpinner = true, ...rest }) => {
  const loaderRef = useRef<SVGSVGElement>(null);

  useLockBodyScroll(visible, loaderRef.current);

  return (
    <Overlay visible={visible} {...rest}>
      {withSpinner && <SpinnerIcon height={SPINNER_SIZE} ref={loaderRef} width={SPINNER_SIZE} />}
    </Overlay>
  );
};

export { FullPageLoader };
